<template>
  <multi-input full :compress="compress">
    <column>
      <div class="sr-only">
        <label :for="month.modelField">{{month.label}}</label>
      </div>
      <a-select
        v-model="document[month.modelField]"
        :placeholder="'Month...'|| month.placeHolder"
        :options="DurationAndTimeHelper.monthOptions"
        @input="monthChange"
        :id="month.modelField"></a-select>
    </column>
    <column>
      <div class="sr-only">
        <label :for="day.modelField">{{day.label}}</label>
      </div>
      <a-select
        v-model="document[day.modelField]"
        :options="daysOptions(document[month.modelField])"
        :placeholder="'Day...'|| day.placeHolder"
        :id="day.modelField"></a-select>
    </column>
  </multi-input>
</template>

<script lang="ts">
  import Vue from 'vue';
  import dateTimeOptionsMixin from "../mixins/dateTimeOptionsMixin";
  import DurationAndTimeHelper from "../helpers/durationAndTimeHelper";

  export default Vue.extend({
    mixins: [dateTimeOptionsMixin],
    data: function () {
      return {
        DurationAndTimeHelper,
      }
    },
    props: {
      document: {
        type: Object,
        required: true
      },
      compress: {
        type: Boolean,
        default: false
      },
      month: {
        type: Object as () => {label: string, modelField: string },
        required: true
      },
      day: {
        type: Object as () => {label: string, modelField: string },
        required: true
      }
    },
    methods:{
      monthChange(e){
        const dayOptions = this.daysOptions(this.document[this.month.modelField]);
        if(!!this.document[this.day.modelField] && !dayOptions[this.document[this.day.modelField]]){
          this.document[this.day.modelField]= dayOptions[dayOptions["length"]-1].value;

        }
      },
    },
  })
</script>
